exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".up[data-v-b2131290]{z-index:10;-o-object-fit:cover;object-fit:cover}.is-flex-direction-column[data-v-b2131290]{-ms-flex-direction:column;flex-direction:column}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b2131290","scoped":true,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/login/SignUpFormBankId.vue
// module id = DJqP
// module chunks = 0 1